import React, { useEffect, useState } from "react";
import logo from "./logo.png";
import "./App.css";
import { styled } from "@mui/material/styles";
import skip from "./skip.png";
import { Alert, Button, responsiveFontSizes, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Option from "./components/Options";
import RadionButton from "./components/RadioButton";
// const bg = require("./bg.jpeg");
const skipcashBlue = "#1e3f91";

const ColorButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText(skipcashBlue),
  backgroundColor: skipcashBlue,
  color: "white",
  textTransform: "capitalize",
  fontFamily: "Nunito",

  "&:hover": {
    backgroundColor: "white",
    borderColor: skipcashBlue,
    borderWidth: 1,
    borderStyle: "solid",
    color: skipcashBlue,
    textTransform: "capitalize",
    fontFamily: "Nunito",
  },
}));

function App() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [name, setName] = useState({
    value: "",
    err: false,
    errTxt: "",
  });
  const [group, setGroup] = useState({
    value: "",
    err: false,
    errTxt: "",
  });

  const [option, setOption] = useState({ value: "", err: false, errTxt: "" });
  const [email, setEmail] = useState({ value: "", err: false, errTxt: "" });
  const options = ["Sibling Discount 10%", "No Discount"];

  const [clicked, setClicked] = useState(false);

  const [totalAmount, setTotalAmount] = useState(1200);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    // getCurrentNumber();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleData = (value, field, index) => {
    if (field === "name") setName({ value, err: false, errTxt: "" });
    else if (field === "group") setGroup({ value, err: false, errTxt: "" });
    else if (field === "email") setEmail({ value, err: false, errTxt: "" });
    else if (field === "options") {
      if (value === "Sibling Discount 10%") {
        setTotalAmount(684);
      } else if (value === "No Discount") {
        setTotalAmount(1000);
      }

      setOption({ value, err: false, errTxt: "" });
    } else console.log("All good");
  };

  const pay = async () => {
    setClicked(true);
    const nameRegEx = /^[A-Za-z ]+$/;
    const numRegEx = new RegExp("^[0-9]*$");
    if (name.value === "") {
      setName({
        value: "",
        err: true,
        errTxt: " Name cannot be empty",
      });
      setClicked(false);

      return;
    }
    if (!nameRegEx.test(name.value)) {
      setName({
        value: "",
        err: true,
        errTxt: " Name can only have English Letters",
      });
      setClicked(false);
      return;
    }
    // if (group.value === "") {
    //   setGroup({
    //     value: "",
    //     err: true,
    //     errTxt: " Group cannot be empty",
    //   });
    //   setClicked(false);

    //   return;
    // }
    if (email.value === "") {
      setEmail({
        value: "",
        err: true,
        errTxt: "Email cannot be empty",
      });
      setClicked(false);

      return;
    }

    // if (option.value === "") {
    //   console.log("inside option");
    //   alert("Please select a discount");
    //   setClicked(false);

    //   return;
    // }

    // alert(amount.value);

    // if (recieve === "") {
    //   alert("Missing or Invalid Details");
    //   setClicked(false);

    //   return;
    // }
    if (totalAmount > 60000) {
      alert("Total Amount Should Be Less than 60000");
      setClicked(false);

      return;
    }

    const url = "https://fame-academy-beffcaf64d41.herokuapp.com/pay";
    //const url = "http://localhost:4000/pay";
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: name.value,
        email: email.value,
        amount: totalAmount,
        discount: `Player: ${name.value}, GFB24 Performance Camp`,
      }),
    });
    const json = await response.json();

    window.location = json.payUrl;
  };

  // useEffect(() => {
  //   calculateTotal();
  // }, [flag]);

  // const calculateTotal = () => {
  //   let total = 0;
  //   setCalculated(true);
  //   if (delivery) total = total + 40;
  //   setTotalAmount(total);
  // };

  const styles = {
    container: {
      //backgroundColor: "#242424",
      width: "100%",
      //height: "auto",
      margin: 0,
      display: "flex",
      overflow: "hidden",
      flex: 1,
      flexDirection: "column",
      //minHeight: "100%",
    },
    whiteContainer: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "5%",
      paddingBottom: "5%",
      // height: "100%",sz
      height: "auto",
    },
    mobileButton: {
      width: "100%",
      padding: "5%",
      borderRadius: 10,
      fontStyle: "Quicksand",
      fontSize: "1em",
      height: 40,
    },
    desktopButton: {
      width: "100%",
      padding: "2%",
      borderRadius: 10,
      fontStyle: "Quicksand",
      fontSize: "1.2em",
      height: 20,
    },
    fontSizeStyle: {
      fontFamily: "Quicksand",
      fontSize:
        windowDimensions.width <= 380
          ? "0.75em"
          : windowDimensions.width <= 500
          ? "0.8em"
          : windowDimensions.width > 500 && windowDimensions.width < 600
          ? "1em"
          : windowDimensions.width >= 600 && windowDimensions.width < 1000
          ? "1em"
          : windowDimensions.width < 1500
          ? "1em"
          : "1em",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.whiteContainer}>
        <div
          style={{
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "transparent",
            borderRadius: 10,
            width: "90%",
            background: "white",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={logo} style={{ height: windowDimensions.height / 4 }} />
          </div>

          <div>
            <div
              style={{
                fontFamily: "Poppins",
                marginLeft: "5%",
                marginRight: "5%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontFamily: "Nunito",
                }}
              >
                <h3>Fame Sports Academy</h3>
              </div>
              <h3 style={{ fontWeight: "bolder" }}>
                GFB24 Performance Camp 17th- 23rd Dec 2025 1200 QAR
              </h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h3 style={styles.fontSizeStyle}>{`Player Name:`}</h3>
                {/* <h3 style={styles.fontSizeStyle}>{`:الاسم `}</h3> */}
              </div>

              <div
                style={{
                  marginTop: "1%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <TextField
                  fullWidth
                  //label="Full Name - الاسم الكامل"
                  id="fullWidth"
                  onChange={(e) => handleData(e.target.value, "name")}
                  error={name.err}
                  helperText={name.errTxt}
                  type="text"
                />
              </div>
              {/* <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h3 style={styles.fontSizeStyle}>{`Group Name:`}</h3>
              </div>

              <div
                style={{
                  marginTop: "1%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <TextField
                  fullWidth
                  //label="Full Name - الاسم الكامل"
                  id="fullWidth"
                  onChange={(e) => handleData(e.target.value, "group")}
                  error={group.err}
                  helperText={group.errTxt}
                  type="text"
                />
              </div> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                {/* <h3 style={styles.fontSizeStyle}>{`:اسم العائلة`}</h3> */}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h3 style={styles.fontSizeStyle}>{`Email Address:`}</h3>
                {/* <h3 style={styles.fontSizeStyle}>{`:البريد الالكتروني`}</h3> */}
              </div>
              <div
                style={{
                  marginTop: "1%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <TextField
                  fullWidth
                  // label="Email Address - البريد الالكتروني"
                  id="fullWidth"
                  onChange={(e) => handleData(e.target.value, "email")}
                  error={email.err}
                  helperText={email.errTxt}
                  type="email"
                />
              </div>

              {/* <h4>Choose A discount</h4>
              <div
                style={{
                  marginTop: "1%",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Option
                  categories={options}
                  handleData={handleData}
                  label={"Tickets"}
                  fontStyle={styles.fontSizeStyle}
                  field={"options"}
                  fullWidth
                  style={{ width: "48%" }}
                />
              </div> */}
              <div
                style={{
                  marginTop: "1.5%",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h3
                  style={{
                    fontFamily: "Nunito",
                    fontSize: "1.1em",
                    opacity: 0.3,
                  }}
                >
                  Total
                </h3>
                <h3
                  style={{
                    fontFamily: "Nunito",
                    fontSize: "1.1em",
                    // opacity: 0.3,
                  }}
                >
                  {`${totalAmount} QAR`}
                </h3>
              </div>
            </div>

            <div
              style={{
                // height: windowDimensions.height / 3,
                display: "flex",
                flex: 1,
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div style={{ width: "90%", padding: "2%" }}>
                {clicked ? (
                  <LoadingButton
                    loading
                    variant="outlined"
                    style={
                      windowDimensions.width < 1000
                        ? styles.mobileButton
                        : styles.desktopButton
                    }
                  >
                    SUBMIT
                  </LoadingButton>
                ) : (
                  <ColorButton
                    onClick={() => pay()}
                    style={
                      windowDimensions.width < 1000
                        ? styles.mobileButton
                        : styles.desktopButton
                    }
                  >
                    Proceed to Pay
                  </ColorButton>
                )}
              </div>

              {/* <h1>hello</h1> */}
            </div>
            <div
              style={{
                // padding: "5%",
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",
              }}
            >
              <img
                src={skip}
                style={
                  windowDimensions.width < 1000
                    ? { height: windowDimensions.width / 8 }
                    : { height: windowDimensions.width / 25 }
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
